<!--
 * @Author: v_smwang
 * @Date: 2020-07-29 16:20:30
 * @LastEditors: v_smwang
 * @LastEditTime: 2020-07-30 21:54:21
 * @FilePath: \src\components\PageView.vue
 * @Description: 描述
 * @Module: 模块路径
-->
<template>
  <div class="page-content">
    <slot>
      <!-- keep-alive  -->
      <keep-alive v-if="multiTab">
        <router-view ref="content" />
      </keep-alive>
      <router-view v-else ref="content" />
    </slot>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PageView',
  components: {},
  props: {},
  data () {
    return {}
  },
  computed: {
    ...mapState({
      multiTab: (state) => state.app.multiTab
    })
  },
  mounted () {},
  updated () {},
  methods: {}
}
</script>

<style lang="less">
.page-content {
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex: 1;
  max-width: 100%;
  width: 100%;
  min-width: 100%;
}
</style>
